import * as era from '!/era'
import { ui } from '!/skin'

const skin = era.skin('widgets/Popups/PinLockPopup/')

PinLockPopup.displayName = 'InfoPopup'
export function PinLockPopup(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='pinLockPopup' />
}
